<router-outlet/>

<app-localstorage-info *ngIf="!environment.production"/>
<app-auth-info *ngIf="!environment.production"/>
